//

((qA) => {
  const questions = [...qA("#faq .question")].map((q) => {
    return {
      title: q.querySelector("& > .title"),
      accordeon: q.querySelector("& > .accordeon"),
    };
  });

  questions.forEach(({ title, accordeon }) => {
    title.addEventListener("click", function () {
      accordeon?.toggleAttribute("open");
    });
  });
})(document.querySelectorAll.bind(document));


